import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'brightside-web-find-money-intro',
    templateUrl: './find-money-intro.component.html',
    styleUrls: ['./find-money-intro.component.scss'],
    standalone: false
})
export class FindMoneyIntroComponent {
  constructor(private _router: Router, private _route: ActivatedRoute) {}

  backToHomePage() {
    this._router.navigate(['home']);
  }

  getStarted() {
    this._router.navigate(['../view'], { relativeTo: this._route });
  }
}
